import partner_1 from '../images/partners/1 (2).png'
import partner_2 from '../images/partners/Hermitage_logo.png'
import partner_3 from '../images/partners/BRICS-3000-768x543-P.png'
import partner_4 from '../images/partners/_-_Deep_Purple_-_Ver.png'
import partner_5 from '../images/partners/__.svg'
import partner_6 from '../images/partners/6.svg'
import partner_7 from '../images/partners/7.png'
import partner_8 from '../images/partners/8.svg'
import partner_9 from '../images/partners/9.svg'
import partner_10 from '../images/partners/10.png'
import partner_11 from '../images/partners/11.svg'
import Stat from '../images/stat.png'

function MainPage() {

  
    return (
      <div id="rec726992974" className="r t-rec" data-animationappear="off" data-record-type="396">
        <div className="t396">
          <div
            className="t396__artboard"
          >
            <div className="t396__carrier" data-artboard-recid="726992974"></div>
            <div className="t396__filter" data-artboard-recid="726992974"></div>
  

            <div
              className="t396__elem tn-elem tn-elem__7269929741608557648581"
              data-elem-id="1608557648581"
              data-elem-type="image"
            >
              <div className="tn-atom">
                <img
                  className="tn-atom__img t-img"
                  src={Stat}
                  alt=""
                  data-original="https://static.tildacdn.com/tild3362-3836-4366-a136-336535336338/2_1.jpeg"
                  imgfield="tn_img_1608557648581"
                />
              </div>
            </div>
  

            <div
              className="t396__elem tn-elem tn-elem__7269929741645794596665"
              data-elem-id="1645794596665"
              data-elem-type="image"
            >
              <div className="tn-atom">
                <img
                  className="tn-atom__img t-img"
                  src="https://static.tildacdn.com/tild3036-3638-4831-b461-356366306637/Logo_expert_nw-monoc.svg"
                  alt=""
                  data-original="https://static.tildacdn.com/tild3036-3638-4831-b461-356366306637/Logo_expert_nw-monoc.svg"
                  imgfield="tn_img_1645794596665"
                />
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741657640684079"
              data-elem-id="1657640684079"
              data-elem-type="text"
            >
              <div className="tn-atom" field="tn_text_1657640684079">
              Global
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741657640684083"
              data-elem-id="1657640684083"
            >
              <div className="tn-atom" field="tn_text_1657640684083">
              The International Global Breakthrough Award is a prestigious award dedicated exclusively to outstanding entrepreneurs and business people who have made significant contributions to the economic development of their countries.<br />
                <br />
                Established by the Business Russia organization, the award is aimed at recognizing those who introduce breakthrough ideas and technologies into business, influence the economy, promote scientific and technological progress and strengthen international relations.
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741608545790530"
              data-elem-id="1608545790530"
              data-elem-type="text"
            >
              <div className="tn-atom" field="tn_text_1608545790530">
              Глобальный Прорыв
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741608545831670"
              data-elem-id="1608545831670"
              data-elem-type="text"
            >
              <div className="tn-atom" field="tn_text_1608545831670">
              Международная Премия «Глобальный Прорыв» — это престижная награда, посвященная исключительно выдающимся предпринимателям и бизнесменам, которые внесли значительный вклад в экономическое развитие своих стран.<br />
                <br />
                Учрежденная организацией «Деловая Россия», премия направлена на признание тех, кто внедряет прорывные идеи и технологии в бизнес, оказывает влияние на экономику, способствует научно-техническому прогрессу и укреплению международных связей.
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741711703005096"
              data-elem-id="1711703005096"
              data-elem-type="text"
            >
              <div className="tn-atom" field="tn_text_1711703005096">
              Breakthrough
              </div>
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741608547024414"
              data-elem-id="1608547024414"
              data-elem-type="text"
            >
              {/* <div className="tn-atom" field="tn_text_1608547024414">
                XIII МЕЖДУНАРОДНАЯ ПРЕМИЯ
              </div> */}
            </div>
  
            {/* Элемент: Текст */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741711703111825"
              data-elem-id="1711703111825"
              data-elem-type="text"
            >
              {/* <div className="tn-atom" field="tn_text_1711703111825">
                XIII INTERNATIONAL AWARD<br />
              </div> */}
            </div>
  
            {/* Элемент: Изображение */}
            <div
              className="t396__elem tn-elem tn-elem__7269929741711703278638"
              data-elem-id="1711703278638"
              data-elem-type="image"

            >
              <div className="tn-atom">
                <img
                  className="tn-atom__img t-img"
                  src="https://static.tildacdn.com/tild3637-3033-4663-b939-306439333764/WhatsApp_Image_2024-.jpeg"
                  alt=""
                  data-original="https://static.tildacdn.com/tild3637-3033-4663-b939-306439333764/WhatsApp_Image_2024-.jpeg"
                  imgfield="tn_img_1711703278638"
                />
              </div>
            </div>
          </div>
        </div>

        <div
  id="rec277271065"
  className="r t-rec t-rec_pt_105 t-rec_pt-res-480_45 t-rec_pb-res-480_0"
  style={{ paddingTop: '105px', backgroundColor: '#d9d2d2' }}
  data-animationappear="off"
  data-record-type="396"
  data-bg-color="#d9d2d2"
>
  <div className="t396">
    <div
      className="t396__artboard"
      data-artboard-recid="277271065"
      data-artboard-screens="320,480,640,960,1200"
    >
      <div className="t396__carrier" data-artboard-recid="277271065"></div>
      <div className="t396__filter" data-artboard-recid="277271065"></div>
      <div
        className="t396__elem tn-elem tn-elem__2772710651612431924343"
        data-elem-id="1612431924343"
      >
        <div className="tn-atom">
          <img
            className="tn-atom__img t-img"
            src="https://static.tildacdn.com/tild6339-3266-4632-b364-373732316536/crystal_.png"
            alt=""
            imgfield="tn_img_1612431924343"
          />
        </div>
      </div>
      <div
        className="t396__elem tn-elem tn-elem__2772710651612428685860"
        data-elem-id="1612428685860"
      >
        <div className="tn-atom" field="tn_text_1612428685860">
        Это признание выдающихся бизнес-лидеров, внедривших инновационные идеи и проекты, которые способствуют развитию экономики и общества. В отличие от рейтингов медийных фигур, премия «Глобальный Прорыв» отмечает профессионалов, чья работа имеет значительное влияние на отрасль. Лауреатами премии становятся самые опытные эксперты, которые заявили о себе масштабными проектами в сфере бизнеса. Ежегодная премия «Глобальный Прорыв» служит платформой для признания ведущих профессионалов, способствующих экономическому росту и повышению конкурентоспособности России и стран СНГ на международном уровне.
          <br />
        </div>
      </div>
      <div
        className="t396__elem tn-elem tn-elem__2772710651612428704625"
        data-elem-id="1612428704625"
      >
        <div className="tn-atom" field="tn_text_1612428704625">
        ГЛОБАЛЬНЫЙ ПРОРЫВ
        </div>
      </div>
      <div
        className="t396__elem tn-elem tn-elem__2772710651612428704628"
        data-elem-id="1612428704628"
      >
        <div className="tn-atom" field="tn_text_1612428704628">
          НАШИ ЦЕЛИ
        </div>
      </div>
    </div>
  </div>
</div>

        

        <div id="rec727024362" className="r t-rec t-rec_pt_0" style={{ paddingTop: '0px' }} data-record-type="396">
      <div className="t396">
        <div
          className="t396__artboard"
          data-artboard-recid="727024362"
          data-artboard-screens="320,480,640,960,1200"
          data-artboard-height="1744"
          data-artboard-valign="center"
          data-artboard-upscale="grid"
          data-artboard-height-res-320="1170"
          data-artboard-height-res-480="1133"
          data-artboard-height-res-640="1481"
          data-artboard-height-res-960="1822"
        >
          <div className="t396__carrier" data-artboard-recid="727024362"></div>
          <div className="t396__filter" data-artboard-recid="727024362"></div>

          {/* Элементы */}
          <div
            className="t396__elem tn-elem tn-elem__7270243621611655460197"
            data-elem-id="1611655460197"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild3236-6535-4533-b933-656437353663/istockphoto_11763011.png"
                alt=""
                data-original="https://static.tildacdn.com/tild3236-6535-4533-b933-656437353663/istockphoto_11763011.png"
                imgfield="tn_img_1611655460197"
              />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621470210011265"
            data-elem-id="1470210011265"
          >
            <div className="tn-atom" field="tn_text_1470210011265">
            «Глобальный Прорыв» имеет высокий международный статус и привлекает лидеров бизнеса, чей вклад формирует экономический ландшафт страны и укрепляет ее позиции на мировой арене. Ежегодно Экспертный Совет премии отмечает профессионалов, которые ведут за собой отрасль, повышая конкурентоспособность и экономический потенциал страны.
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621580314144650"
            data-elem-id="1580314144650"
          >
            <div className="tn-atom" field="tn_text_1580314144650">
            География участников премии «Глобальный Прорыв» охватывает весь СНГ, что подчеркивает её международный статус и значимость. В конкурсе ежегодно участвуют представители России, Казахстана, Беларуси, Армении, Узбекистана, Грузии, Киргизии, Азербайджана, Таджикистана, Туркменистана и Молдовы, Украины. Этот широкий охват способствует укреплению деловых связей и обмену опытом между странами, а также позволяет продемонстрировать лучшие бизнес-практики, объединяя предпринимателей из различных регионов и формируя единую платформу для взаимодействия и сотрудничества. Премия способствует не только развитию национальных экономик, но и поддерживает идею единства и партнерства среди стран СНГ.
            </div>
          </div>
          <div
            className="t396__elem tn-elem "
            data-elem-id="1680314144650"
          >
            <div className="tn-atom" field="tn_text_1680314144650">
            Лауреатами премии становятся признанные предприниматели с многолетним опытом, проявившие себя в самых разнообразных отраслях. Эти люди — создатели инновационных проектов и предприятий, которые определяют будущее, продвигают культуру предпринимательства и способствуют росту деловой активности.
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621580314561472"
            data-elem-id="1580314561472"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild3665-6435-4737-a334-666235346163/small-ball.png"
                alt=""
                data-original="https://static.tildacdn.com/tild3665-6435-4737-a334-666235346163/small-ball.png"
                imgfield="tn_img_1580314561472"
              />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621580314582834"
            data-elem-id="1580314582834"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild6434-3230-4662-a530-343530326331/gauss-ball.png"
                alt=""
                data-original="https://static.tildacdn.com/tild6434-3230-4662-a530-343530326331/gauss-ball.png"
                imgfield="tn_img_1580314582834"
              />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621611655460193"
            data-elem-id="1611655460193"
          >
            <div className="tn-atom" field="tn_text_1611655460193">
              12 НОМИНАЦИЙ. 12 ЭКСПЕРТОВ
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621611655506528"
            data-elem-id="1611655506528"
          >
            <div className="tn-atom" field="tn_text_1611655506528">
              ОДИН ИЗ НИХ — ВЫ
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621611656625373"
            data-elem-id="1611656625373"
          >
            <div className="tn-atom" field="tn_text_1611656625373">
            ВЫСОКИЙ СТАТУС
            </div>
            
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621611656690011"
            data-elem-id="1611656690011"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild6434-3230-4662-a530-343530326331/gauss-ball.png"
                alt=""
                data-original="https://static.tildacdn.com/tild6434-3230-4662-a530-343530326331/gauss-ball.png"
                imgfield="tn_img_1611656690011"
              />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7270243621611656700911"
            data-elem-id="1611656700911"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild3665-6435-4737-a334-666235346163/small-ball.png"
                alt=""
                data-original="https://static.tildacdn.com/tild3665-6435-4737-a334-666235346163/small-ball.png"
                imgfield="tn_img_1611656700911"
              />
            </div>
          </div>

          {/* Элемент с пустым контентом */}
          {/* <div
            className="t396__elem tn-elem tn-elem__7270243621711711921635"
            data-elem-id="1711711921635"
          >
            <div className="tn-atom"></div>
          </div> */}

          <div
            className="t396__elem tn-elem tn-elem__7270243621729939573110"
            data-elem-id="1729939573110"
          >
            <div className="tn-atom" field="tn_text_1729939573110">
              В рамках международной премии «Глобальный Прорыв» вручается 12 номинаций
            </div>
          </div>
        </div>
      </div>
    </div>



    <div
      id="rec816830968"
      className="r t-rec t-rec_pt_75 t-rec_pt-res-480_45 t-rec_pb_75 t-rec_pb-res-480_45"
      style={{ paddingTop: '75px', paddingBottom: '75px', backgroundColor: '#e7c8af' }}
      data-record-type="502"
      data-bg-color="#e7c8af"
    >
      <div className="t502">
        <ul role="list" className="t502__container t-list__container_inrow3 t-container">
          {/* Первый элемент списка */}
          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  1
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__8873100789290">
                  <strong>Международные достижения</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__8873100789290">
                Номинация для бизнесменов и предпринимателей, чьи компании реализовали значимые инициативы на международных рынках, способствуя развитию отрасли и укреплению позиций за рубежом.
                </div>
              </div>
            </div>
          </li>

          {/* Второй элемент списка */}
          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  2
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__8873100789291">
                  <strong>Финансы и инвестиции
                  </strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__8873100789291">
                Для бизнесменов и профессионалов, достигших выдающихся результатов в финансовом секторе — банках, инвестиционных фондах, страховых и лизинговых компаниях, способствуя устойчивому развитию и инновациям в отрасли.
                </div>
              </div>
            </div>
          </li>


          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  3
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__8873100789293">
                  <strong>Строительство и девелопмент</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__8873100789293">
                Награда для предпринимателей, успешно реализовавших проекты в строительстве и девелопменте, которые развивают городскую среду, расширяют инфраструктуру и улучшают качество жизни.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  4
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__8873100789294">
                  <strong>Ритейл и торговля
                  </strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__8873100789294">
                Для бизнесменов и владельцев компаний, добившихся выдающихся успехов в розничной и оптовой торговле, внедривших передовые подходы и значительно улучшивших клиентский сервис.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                 5
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__8873100789295">
                  <strong>Туризм и гостеприимство</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__8873100789295">
                Для предпринимателей, реализующих проекты в туристической, гостиничной и ресторанной индустрии, которые повысили качество сервиса и способствуют росту индустрии гостеприимства.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  6
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941146391">
                  <strong>Маркетинг и коммуникации</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941146391">
                Номинация для бизнесменов, развивающих проекты в сфере маркетинга, бренд-стратегий и маркетинговых технологий, направленные на повышение эффективности продвижения, улучшение взаимодействия с аудиторией и рост коммерческих результатов.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  7
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941154772">
                  <strong>Транспортные инженерные технологии</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941154772">
                Для инженеров и предпринимателей, добившихся выдающихся результатов в разработке инновационных транспортных технологий, инженерных решений, способствующих развитию транспортной отрасли.
                </div>
              </div>
            </div>
          </li>

          {/* Девятый элемент списка */}
          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  8
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941170050">
                  <strong>Инновации и технологии</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941170050">
                Награда для бизнесменов, чьи проекты внесли значительный вклад в развитие отрасли за счет внедрения инновационных технологий и повысили ее конкурентоспособность.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  9
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941182056">
                  <strong>Ресторанный бизнес</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941182056">
                Качество концепции и клиентского опыта, операционная эффективность, инновации в управлении и сервисе, масштабируемость бизнес-модели, влияние на отрасль и экономическая устойчивость.
                </div>
              </div>
            </div>
          </li>


          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  10
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941190680">
                  <strong>Спорт и активный образ жизни</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941190680">
                Награда для бизнесменов, поддерживающих и развивающих спортивные проекты, программы по пропаганде здорового образа жизни, которые помогают популяризировать спорт и физическую активность среди широких слоев населения.
                </div>
              </div>
            </div>
          </li>

          <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  11
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941197810">
                  <strong>Психология и личностное развитие</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941197810">
                Номинация для предпринимателей, внедряющих инновации в сфере психологических услуг, курсов личностного роста и поддержки психического здоровья, способствующих эмоциональному благополучию и развитию навыков у широкой аудитории
                </div>
              </div>
            </div>
          </li>

         <li className="t502__col t-col t-col_4 t-list__item t-align_left t-item">
            <div className="t502__tablewrapper">
              <div className="t502__circlewrapper">
                <div
                  className="t502__circle t-title"
                  style={{ backgroundColor: '#fff5ec', color: '#e7c8af' }}
                >
                  12
                </div>
              </div>
              <div className="t502__textwrapper">
                <div className="t502__title t-name t-name_sm" field="li_title__1729941197810">
                  <strong>Мода и стиль</strong>
                </div>
                <div className="t502__blockdescr t-descr t-descr_xs" field="li_descr__1729941197810">
                Номинация для предпринимателей, внедряющих инновации в индустрии моды, красоты и персонального стиля, создающих тренды, развивающих устойчивый и этичный подход к производству и потреблению, а также формирующих новое видение эстетики и самовыражения для широкой аудитории.
                </div>
              </div>
            </div>
          </li>          
        </ul>
      </div>
    </div>
    

    <div
        id="rec727224927"
        className="r t-rec t-rec_pt_105 t-rec_pb_0"
        style={{ paddingTop: '105px', paddingBottom: '0px', backgroundColor: '#d9d2d2' }}
        data-record-type="795"
        data-bg-color="#d9d2d2"
        data-animationappear="off"
      >
        <div className="t795">
          <div className="t-container t-align_center">
            <div className="t-col t-col_10 t-prefix_1">
              <div className="t795__title t-title t-title_xs t-margin_auto" field="title">
                ПАРТНЁРЫ ПРЕМИИ «ГЛОБАЛЬНЫЙ ПРОРЫВ»
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="rec727224929"
        className="r t-rec t-rec_pt_0 t-rec_pt-res-480_0 t-rec_pb_0 t-rec_pb-res-480_0"
        style={{ paddingTop: '0px', paddingBottom: '0px', backgroundColor: '#d9d2d2' }}
        data-record-type="121"
        data-bg-color="#d9d2d2"
      >
        <div className="t594">
          <div className="t594__container t-card__container t-container">
            {/* Первый партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://www.wwclub.spb.ru/" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_1}
                  imgfield="li_img__1625040363093"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Второй партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a
                href="https://www.hermitagemuseum.org/wps/portal/hermitage?lng=ru"
                className="t-card__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_2}
                  imgfield="li_img__1618390318107"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Третий партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://tvbrics.com" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_3}
                  imgfield="li_img__1706698169989"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Четвертый партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://www.uralsib.ru/" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_4}
                  imgfield="li_img__1481205740884"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Пятый партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://expert.ru" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_5}
                  imgfield="li_img__1708073645585"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Шестой партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://вэб.рф" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_6}
                  imgfield="li_img__1716477993159"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Седьмой партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://expoforum-center.ru" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_7}
                  imgfield="li_img__1712658312712"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Восьмой партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a
                href="https://longreads.expertnw.com/rdlab_rudn"
                className="t-card__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_8}
                  imgfield="li_img__1729934581998"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Девятый партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a
                href="https://longreads.expertnw.com/rudn"
                className="t-card__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_9}
                  imgfield="li_img__1729934887480"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Десятый партнер */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <a href="https://kamergermoscow.ru" className="t-card__link" target="_blank" rel="noopener noreferrer">
                <img
                  className="t594__img t-img t594__greyonhovercolor"
                  src={partner_10}
                  imgfield="li_img__1729936937806"
                  style={{ maxWidth: '160px' }}
                  alt=""
                />
              </a>
            </div>

            {/* Одиннадцатый партнер (без ссылки) */}
            <div className="t-card__col t-card__col_withoutbtn t594__item t594__item_4-in-row">
              <img
                className="t594__img t-img t594__greyonhovercolor"
                src={partner_11}
                imgfield="li_img__1729938542111"
                style={{ maxWidth: '160px' }}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>


      </div>
    );
  };

  

export default MainPage;